import { Injectable, OnInit } from '@angular/core'
import {
  OCC_USER_ID_ANONYMOUS,
  OCC_USER_ID_CURRENT,
  UserIdService,
  WindowRef
} from '@spartacus/core'
import { CookieService } from 'ngx-cookie-service'
import { BehaviorSubject, Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class EbUserIdService extends UserIdService implements OnInit {
  userIsEmulated$ = new BehaviorSubject(false)
  private ebUserId$ = new BehaviorSubject(OCC_USER_ID_ANONYMOUS)

  constructor(
    protected cookieService: CookieService,
    protected winRef: WindowRef
  ) {
    super()
  }

  ngOnInit() {
    this.setUserEmulatedState()
  }

  private getVerifiedUserId() {
    if (this.accessToken) {
      if (this.ebUserId$.value === OCC_USER_ID_ANONYMOUS) {
        this.ebUserId$.next(OCC_USER_ID_CURRENT)
      }
    } else {
      if (this.ebUserId$.value === OCC_USER_ID_CURRENT) {
        this.ebUserId$.next(OCC_USER_ID_ANONYMOUS)
      }
    }
    return this.ebUserId$
  }

  public getUserId(): Observable<string> {
    return this.getVerifiedUserId()
  }

  public takeUserId(loggedIn = false): Observable<string> {
    return this.getVerifiedUserId().pipe(
      take(1),
      map(userId => {
        if (loggedIn && userId === OCC_USER_ID_ANONYMOUS) {
          throw new Error('Requested user id for logged user while user is not logged in.')
        }
        return userId
      })
    )
  }

  public setUserId(userId?: string): void {
    if (this.accessToken) {
      this.ebUserId$.next(OCC_USER_ID_CURRENT)
    } else {
      this.ebUserId$.next(OCC_USER_ID_ANONYMOUS)
    }
  }

  public isEmulated(): Observable<boolean> {
    return this.userIsEmulated$
  }

  setUserEmulatedState(state = true) {
    if (this.accessToken && this.cookieService.get('asAgent') && state) {
      this.userIsEmulated$.next(state)
    } else {
      this.userIsEmulated$.next(false)
    }
  }

  get accessToken() {
    return (
      this.cookieService.get('access_token') ||
      this.cookieService.get('temp_customer_emulation_token')
    )
  }
}
